module.exports = __webpack_public_path__ + "img/postgressql.34cbdb15.svg";